export default __webpack_public_path__ + "static/media/FiraSans-Italic.3b21f231.ttf";